module.exports = "<uch></uch>\r\n<head-title params='title:\"应用列表 / 授权列表 / 属性编辑\"'></head-title>\r\n<div class=\"userContBottom\">\r\n    <div class=\"userContent\">\r\n        <attr-item></attr-item>\r\n    </div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/component/appConfig/template/editAttrIndex.html
// module id = 194
// module chunks = 0